import React from 'react';
import { ProductImage } from './ProductImage';

export function ProductImageExample(): JSX.Element {
  return (
    <ProductImage
      imgSrc="https://ks-staging.nerdgeschoss.de/api/v2/assets/478406cc-489e-447c-8053-15f6e1ab268f.png"
      isPreview
      // setPreview={() => {}}
      // deleteImage={() => {}}
    />
  );
}
